import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1045"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8 .5a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15zM1.9 8c0-3.364 2.736-6.1 6.1-6.1 1.385 0 2.659.469 3.684 1.249L8.19 7.325l-.476-.438c.28-.362.488-.653.488-.713a2.542 2.542 0 0 0-2.539-2.55c-.183 0-.626.077-.671.089a.236.236 0 0 0-.104.395l1.276 1.275a.9.9 0 0 1 .263.641.902.902 0 0 1-.903.903.902.902 0 0 1-.641-.263L3.608 5.388a.236.236 0 0 0-.394.104c-.013.045-.09.488-.09.671a2.543 2.543 0 0 0 3.063 2.485c.039-.008.184-.156.381-.376l.47.431-3.158 3.773-.004.007A6.082 6.082 0 0 1 1.9 8zM8 14.1a6.062 6.062 0 0 1-2.992-.79L8.07 9.65l2.385 2.189a.893.893 0 0 0 1.268-.058.897.897 0 0 0-.058-1.267L9.222 8.272 12.7 4.116A6.073 6.073 0 0 1 14.1 8c0 3.364-2.736 6.1-6.1 6.1z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }